const module = { name: 'fd-url-manager', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from '@grins/fd-modules/splits/require-core';

const { context: { _routes: routeDefinitions } } = Fandango_context;


const RegExes = {
    SPACE: /\s/g,
    UNSAFE_CHARS: /[^a-z0-9\s]/gi,
}


const Errors = {
    DUPLICATE_ROUTE: 'Route with name "%s" exists'
}


const linkFunctions = {}


const linkTokens = {}
function toValue(opts, value) {
    if (value === null || typeof value === 'undefined') {
        return '';
    }
    let results = value.toString();
    if (!opts) {
        return results;
    }
    if (opts.lowercase) {
        results = results.toLowerCase();
    }
    if (opts.encode) {
        results = encodeURIComponent(results);
    }
    if (opts.strip) {
        results = results.replace(RegExes.UNSAFE_CHARS, '');
    }
    if (typeof opts.replaceSpaces === 'undefined' || typeof opts.replaceSpaces === 'string') {
        results = results.replace(RegExes.SPACE, opts.replaceSpaces || '-');
    }
    return results;
}
function qsStringify(params) {
    if (!params || typeof params !== 'object') {
        return '';
    }
    const values = [];
    for (const key in params) {
        if (hasOwnProperty.call(params, key)) {
            values.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
        }
    }
    if (!values.length) {
        return '';
    }
    return values.join('&');
}
function addQueryParams(url, params) {
    if (typeof url !== 'string') {
        return url;
    }
    const str = qsStringify(params);
    if (!str) {
        return url;
    }
    return url + (url.indexOf('?') < 0 ? '?' : '&') + str;
}
function getLink(name, params, queryParams) {
    const linkInfo = linkTokens[name];
    if (!linkInfo || !linkInfo.tokens) {
        return '';
    }
    if (!params) {
        return addQueryParams(linkInfo.path || '', queryParams);
    }
    let results = '';
    linkInfo.tokens.forEach((data) => {
        if (data.literal) {
            results += data.literal || '';
            return;
        }
        const opts = params[data.key];
        if (typeof opts === 'undefined' || opts === null) {
            results += ':' + data.key;
        }
        else {
            results += toValue(opts, typeof opts === 'object' ? opts.value : opts) || (':' + data.key);
        }
    });
    results = addQueryParams(results, queryParams);
    return results;
}
function register(linkInfo, name) {
    if (linkTokens[name]) {
        throw new Error(Errors.DUPLICATE_ROUTE.replace('%s', name));
    }
    linkTokens[name] = {
        path: linkInfo.path,
        tokens: linkInfo.tokens || linkInfo.pathTokens
    };
    linkFunctions[name] = getLink.bind(this, name);
}
function importRegistry(linkRegistry) {
    for (const name in linkRegistry) {
        register(linkRegistry[name], name);
    }
    return linkFunctions;
}
function extendLegacy(publicInterface, sectionName) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[sectionName]) {
        Fandango[sectionName] = publicInterface;
    }
}
function getPublicInterface(routeDefinitions) {
    return Object.assign({
        __testable__: {
            register,
        },
    }, importRegistry(routeDefinitions));
}


const moduleExports = getPublicInterface(routeDefinitions || {})
module.exports = moduleExports;
extendLegacy(module.exports, 'link');
export default module.exports;